"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPhoneErrorSelector = hasPhoneErrorSelector;
exports.isFormSubmitting = isFormSubmitting;
exports.phoneErrorSelector = phoneErrorSelector;
exports.viewStateEmailSelector = viewStateEmailSelector;
var _authentication = require("../../../../types/authentication");
var _flow = require("../../../../types/flow");
var _registration = require("../../../../types/registration");
var _validation = require("../../../../utils/validation");
function viewStateEmailSelector(state) {
  const {
    data: viewData
  } = state.view;
  if (viewData && viewData.email) {
    return viewData.email;
  } else if (state.login && (0, _validation.isEmail)(state.login)) {
    return state.login;
  }
  return '';
}
function isFormSubmitting(state) {
  const {
    activeFlow,
    authentication,
    registration
  } = state;
  if (activeFlow === _flow.EActiveFlow.Registration) {
    return registration.register.status === _registration.ERegisterStatus.Loading || registration.register.status === _registration.ERegisterStatus.Succeed;
  } else if (activeFlow === _flow.EActiveFlow.Authentication) {
    return authentication.authenticate.status === _authentication.EAuthenticateStatus.Loading || authentication.authenticate.status === _authentication.EAuthenticateStatus.Succeed;
  } else {
    return authentication.checkEmail.status === _authentication.ECheckEmailStatus.Loading;
  }
}
function hasPhoneErrorSelector(state) {
  return state.registration.register.error !== undefined && state.registration.register.errorType === _registration.ERegisterErrorType.Phone;
}
function phoneErrorSelector(state) {
  return hasPhoneErrorSelector(state) ? state.registration.register.error : undefined;
}